import instance from "helpers/api";
import { commonSlice } from "./reducers";
import { authSlice } from "../auth/reducers";
// import { authSlice } from "redux/auth/reducers.js";
import { setStorage } from "helpers/storage";
import roles from "helpers/roles";
import { REMOVE_SESSIONS } from "helpers/constants";
import { getAPIResponse } from "helpers/getApiResponse";

const {
	setError,
	removeError,
	setLoading,
	openHistoryDrawer,
	setShowData,
	setSuccess,
	removeSuccess,
	setWarning,
	removeWarning,
	setFeedbackLoginFlag,
} = commonSlice.actions;
const { dataSuccess } = authSlice.actions;

export const showError = (message) => (dispatch) =>
	dispatch(setError({ message }));
export const showSuccess = (message) => (dispatch) =>
	dispatch(setSuccess({ message }));
export const showWarning = (message, items = []) => (dispatch) =>
	dispatch(setWarning({ message, items }));

export const loginWithSiteAppId =
	(id, redirect = true) =>
	async (dispatch) => {
		dispatch(setLoading({ loading: true }));

		try {
			// Store the current URL before switching
			const currentPath = window.location.pathname + window.location.search;

			const res = await instance.get(`/api/Users/LoginToSiteApp/${id}`);
			localStorage.setItem("siteAppId", id);
			localStorage.setItem(
				"clientUserId",
				sessionStorage.getItem("clientUserId")
			);
			localStorage.setItem("isAdmin", sessionStorage.getItem("isAdmin"));
			const data = {
				...res.data,
				isAdmin: localStorage.getItem("isAdmin") === "true",
				isSiteUser: true,
				weekStartDay: res.data.application.weekStartDay,
			};
			const response = await setStorage(data);
			if (response.role === roles.clientAdmin) {
				localStorage.removeItem("clientAdminMode");
			}
			localStorage.removeItem("siteAppId");
			localStorage.removeItem("isAdmin");
			dispatch(dataSuccess({ data }));

			dispatch(setLoading({ loading: false }));
			// redirect to original URL if user logged in from the Application Portal
			if (redirect) {
				// Redirect back to the original URL
				window.location.href = currentPath;

				return res;
			}
			// Remove session and return response without redirecting ,if the user logged in from  the Email link or external link
			REMOVE_SESSIONS.forEach((elem) => {
				sessionStorage.removeItem(elem);
			});
			return getAPIResponse(res);
		} catch (error) {
			dispatch(setLoading({ loading: false }));
			return getAPIResponse(error?.response);
		}
	};

export const hideError = () => (dispatch) => dispatch(removeError());
export const hideSuccess = () => (dispatch) => dispatch(removeSuccess());
export const hideWarning = () => (dispatch) => dispatch(removeWarning());

export const setHistoryDrawerState = (payload) => (dispatch) =>
	dispatch(openHistoryDrawer({ historyDrawerState: payload }));

//showData for analytics page
export const setAnalyticsShowData = (payload) => (dispatch) => {
	dispatch(
		setShowData({ showData: payload.data, showDataState: payload.state })
	);
};
// function to set feedback login state
export const setLoggedInFromFeedbackUrl = (payload) => (dispatch) =>
	dispatch(setFeedbackLoginFlag({ isLoggedInFromFeedbackUrl: payload }));
